import { useEffect } from 'react';

interface UseGlobalBtnDisplayProps {
  state: boolean;
  deps: unknown[];
}

const useGlobalBtnDisplay = ({ state, deps }: UseGlobalBtnDisplayProps) => {
  useEffect(() => {
    const topBtnEl = document.getElementById('topBtn');
    const gitpleEl = document.getElementById('gitple-launcher');
    if (topBtnEl) {
      topBtnEl.style.display = state ? 'none' : 'flex';
    }
    if (gitpleEl) {
      gitpleEl.style.display = state ? 'none' : 'block';
    }
  }, deps);
};

export default useGlobalBtnDisplay;
